import React, { useContext } from "react";

import { PrivateContext } from "lib/context";
import { storageHelper } from "lib/helpers";
import { SkeletonAnnotated } from "lib/components";
import constant from "lib/constant/constant";
import OperatorSellerPlan from "./operator/features/managePlan/add";

const { userKey } = constant;
const { operator } = userKey;

const AddSellerPlan = () => {
  const { isLoading } = useContext(PrivateContext);
  const currentUserRole = storageHelper.get("userRole");
  const getComponent = (role) => {
    if (isLoading) {
      return <SkeletonAnnotated />;
    }
    if (role === operator) {
      return <OperatorSellerPlan />;
    }
    return null;
  };
  const managePlans = getComponent(currentUserRole);
  return managePlans;
};

export default AddSellerPlan;
